import _ from 'lodash';

const formatPercent = function (value) {
    let rounded = _.toNumber(value).toFixed(2);
    return _.chain(rounded).toString().trimEnd("0").trimEnd('.').value();
};

export {formatPercent};